import React from 'react';
import { Rectangle } from 'recharts';

// Enhanced clickable bar - Simplified to avoid yAxis dependency issue
const CustomBar = (props) => {
    const { x, y, width, height, fill, name, onClick } = props;

    // Check if coordinates and dimensions are valid numbers before rendering
    const isValidNumber = (...args) => args.every(n => typeof n === 'number' && !isNaN(n));

    if (!isValidNumber(x, y, width, height)) {
        // Don't render the bar or its parts if geometry is invalid
        console.warn('Invalid geometry for CustomBar:', props);
        return null;
    }

    return (
        <g onClick={() => onClick(name)} style={{ cursor: 'pointer' }}>
            {/* Invisible extended clickable area (from chart top to bar top) */}
            {/* Render only if y is positive */}
            {y > 0 && (
                <Rectangle
                    x={x}
                    y={0} // Start from the top of the plot area
                    width={width}
                    height={y} // Extend down to the top of the visible bar
                    fill="transparent"
                />
            )}
            {/* The visible bar */}
            <Rectangle
                x={x}
                y={y}
                width={width}
                height={height}
                fill={fill}
                stroke="#fff"
                strokeWidth={1}
                rx={2}
                ry={2} />
            {/* Subtle hover effect overlay */}
            <Rectangle
                x={x}
                y={y}
                width={width}
                height={height}
                fill={fill} // Use the same fill
                fillOpacity={0} // Start transparent
                className="bar-hover-effect" // Use CSS for transition
            />
        </g>
    );
};

export default CustomBar;